import { z } from 'zod';

export type DiscountFormSchemaValues = z.infer<typeof discountFormSchema>;
export const discountFormSchema = z.object({
    start_date: z.string().nonempty(),
    end_date: z.string().optional().nullable(),
    discount_policy: z.string().nonempty(),
    subscription: z.string().nonempty(),
    subscription_item: z.string().optional().nullable(),
});
